import React, { useMemo } from "react";
import { Button, TableRow } from "@material-ui/core";
import StyledTableCell from "./styled-table-sell";
import { useTranslation } from "react-i18next";
import { useCancelPayoutMutation, useConfirmPayoutMutation } from "../../../api/payout";
import { useDispatch, useSelector } from "react-redux";
import { getAlltables, tableSelector } from "../../../redux/tableReducer";
import { authSelector } from "../../../redux/authReducer";

interface TableRowProps {
    payment: Payment;
    hall_id: number;
}

let isTablesInit = false;
const PayoutTableRow: React.FC<TableRowProps> = ({ payment, hall_id }) => {
    const [confirm, { isLoading: isConfirmation }] = useConfirmPayoutMutation();
    const [cancel, { isLoading: isCancelling }] = useCancelPayoutMutation();
    const { tables: { data: tables } } = useSelector(tableSelector);
    const table = useMemo(() => tables.find(t => t.id === payment.gambling_table_id), [tables, payment]);
    const { status } = useSelector(authSelector);
    const dispatch = useDispatch();
    React.useEffect(() => {
        if (!isTablesInit && status === 200 && tables.length === 0) {
            isTablesInit = true;;
            dispatch(getAlltables(1, 50));
        }
    }, [dispatch, status, tables]);
    const [t] = useTranslation(); return <TableRow>
        <StyledTableCell>{payment.id}</StyledTableCell>
        <StyledTableCell>{payment.gambling_table_id}</StyledTableCell>
        <StyledTableCell>{table?.login}</StyledTableCell>
        <StyledTableCell>{t(`ru.payout.selectors.type${payment.type}`)}</StyledTableCell>
        <StyledTableCell>{((payment.total_sum === 0 ? payment.sum : payment.total_sum) / 100).toFixed(2)}</StyledTableCell>
        <StyledTableCell>{t(`ru.payout.selectors.status${payment.status}`)}</StyledTableCell>
        <StyledTableCell>{payment.service.length > 23 ? payment.service.substring(23) : payment.service}</StyledTableCell>
        <StyledTableCell>
            <Button size="small" color="default" variant="contained" onClick={() => navigator.clipboard.writeText(JSON.stringify(payment.data, null, 2))}>Копировать</Button>
        </StyledTableCell>
        <StyledTableCell>
            {payment.history.length > 0 && <Button size="small" color="default" variant="contained" onClick={() => navigator.clipboard.writeText(JSON.stringify(payment.history, null, 2))}>Копировать</Button>}
        </StyledTableCell>
        <StyledTableCell>{(new Date(1000 * payment.created_at)).toLocaleString("RU-ru")}</StyledTableCell>
        <StyledTableCell style={{ gap: "2px", display: "flex" }}>
            {[0, 1].includes(payment.status) && <Button disabled={isConfirmation || isCancelling} size="small" color="primary" variant="contained" onClick={() => cancel({ hall_id, id: payment.id })}>Отменить</Button>}
            {[0, 2, 3, 4].includes(payment.status) && <Button disabled={isConfirmation || isCancelling} size="small" color="primary" variant="contained" onClick={() => confirm({ hall_id, id: payment.id })}>Подтвердить</Button>}
        </StyledTableCell>
    </TableRow>;
}

export default PayoutTableRow;
